import styled from 'styled-components';
import { Select } from '@landlord-tech/ui-kit-opp/dist/components/Select';

export const SSelect = styled(Select)`
  &&& {
  }
`;
